import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.ruyan.app/api';

const api = axios.create({ baseURL: API_BASE_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('admin_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  },
);

export interface LandingDream {
  id: string;
  capturedAt: string;
  serverReceivedAt: string;
  ip: string;
  userAgent: string | null;
  locale: string;
  pageUrl: string | null;
  symbolSlug: string;
  email: string | null;
  dreamText: string;
  interpretation: string | null;
  interpretedAt: string | null;
}

export interface LandingDreamsListResponse {
  ok: boolean;
  total: number;
  offset: number;
  limit: number;
  items: LandingDream[];
}

export interface LandingDreamsStats {
  ok: boolean;
  total: number;
  last24h: number;
  last7d: number;
  last30d: number;
  pendingInterpretation: number;
  withEmail: number;
  byLocale: Record<string, number>;
  bySymbolTop10: { symbol: string; count: number }[];
}

export const landingDreamsService = {
  async list(params: {
    limit?: number;
    offset?: number;
    q?: string;
    locale?: string;
    interpreted?: 'true' | 'false' | '';
  } = {}): Promise<LandingDreamsListResponse> {
    const { data } = await api.get('/admin/landing-dreams', { params });
    return data;
  },

  async stats(): Promise<LandingDreamsStats> {
    const { data } = await api.get('/admin/landing-dreams/stats/summary');
    return data;
  },

  async byId(id: string): Promise<{ ok: boolean; dream: LandingDream }> {
    const { data } = await api.get(`/admin/landing-dreams/${id}`);
    return data;
  },
};
